import { getUserMailboxInfo } from 'owa-client-ids';
import { trace } from 'owa-trace';
import { lazyUpdateUserConfigurationService } from 'owa-update-user-configuration-service';

export const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';
export const USER_OPTIONS_CONFIGURATION: string = 'OWA.UserOptions';

const UPDATE_SELECTED_CALENDARS_VIEW_STATE_DELAY_MS = 5 * 1000;

let updateSelectedCalendarsViewStateTimer: any = null;
let selectedCalendarsViewState: string[];

export function updateSelectedCalendarsState(
    selectedCalendars: string[],
    primarySmtpAddress: string
) {
    const mailboxInfo = getUserMailboxInfo(primarySmtpAddress);
    selectedCalendarsViewState = selectedCalendars;
    if (selectedCalendarsViewState) {
        // Save this changes with a timer so we can batch all of them together.
        if (!updateSelectedCalendarsViewStateTimer) {
            updateSelectedCalendarsViewStateTimer = setTimeout(function() {
                // Clear the time handle.
                updateSelectedCalendarsViewStateTimer = null;

                // Make the call.
                lazyUpdateUserConfigurationService
                    .importAndExecute(
                        VIEW_STATE_CONFIGURATION,
                        {
                            // Key
                            Type: 'String',
                            Value: ['SelectedCalendarsDesktop'],
                        },
                        {
                            // Value
                            Type: 'StringArray',
                            Value: selectedCalendarsViewState,
                        },
                        mailboxInfo
                    )
                    .catch(error => {
                        trace.warn(
                            'Could not save new selected calendars list to user configuration'
                        );
                    });
            }, UPDATE_SELECTED_CALENDARS_VIEW_STATE_DELAY_MS);
        }
    }
}
